import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteCompetitionTrainersStart:
    '[delete competition Trainers] Delete competition Trainers start',
  deleteCompetitionTrainersSuccess:
    '[delete competition Trainers] Delete competition Trainers success',
  deleteCompetitionTrainersFailure:
    '[delete competition Trainers] Delete competition Trainers failure',
}

export const actionTypes = {
  deleteCompetitionTrainers:
    '[delete competition Trainers] Delete competition Trainers',
}

const mutations = {
  [mutationTypes.deleteCompetitionTrainersStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteCompetitionTrainersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteCompetitionTrainersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteCompetitionTrainers](context, {id}) {
    context.commit(mutationTypes.deleteCompetitionTrainersStart)
    return new Promise((resolve) => {
      apiCompetitions
        .deleteCompetitionTrainers(id)
        .then((response) => {
          context.commit(mutationTypes.deleteCompetitionTrainersSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteCompetitionTrainersFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
